import { render, staticRenderFns } from "./makeMethodMange.vue?vue&type=template&id=1919daf2&scoped=true"
import script from "./makeMethodMange.vue?vue&type=script&lang=js"
export * from "./makeMethodMange.vue?vue&type=script&lang=js"
import style0 from "./makeMethodMange.vue?vue&type=style&index=0&id=1919daf2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919daf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1919daf2')) {
      api.createRecord('1919daf2', component.options)
    } else {
      api.reload('1919daf2', component.options)
    }
    module.hot.accept("./makeMethodMange.vue?vue&type=template&id=1919daf2&scoped=true", function () {
      api.rerender('1919daf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/goodsManage/makeMethodMange.vue"
export default component.exports